import { View, Text } from "@react-pdf/renderer";
import {
  getTime,
  getSubs,
  getStartingPlayers,
  getPeriodArray,
  getPlayerById,
} from "../functions/Helper.js";

export default function SubstitutionSheetPDF({
  periods,
  minutes,
  periodLength,
  players,
  positionLabels,
  showSwitches,
  ...props
}) {
  return (
    <View>
      {getPeriodArray(periods).map((period, index) => {
        return (
          <View key={"period_" + index} style={{ marginBottom: 20 }}>
            <View
              wrap={false}
              style={{
                paddingTop: 4,
                paddingBottom: 4,
                paddingLeft: 5,
                paddingRight: 5,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Text style={{ fontWeight: "600", fontSize: 12 }}>
                {period}. {periods === 2 ? "Half" : "Quarter"}
              </Text>
            </View>

            <View
              style={{ marginTop: 10, display: "flex", flexDirection: "row" }}
            >
              <View
                style={{
                  width: 60,
                  fontWeight: "600",
                  fontSize: 14,
                }}
              >
                <Text style={{ fontSize: 8 }}>Starting:</Text>
              </View>
              <View style={{ fontSize: 14 }}>
                {getStartingPlayers(minutes, period, periodLength).map(
                  (minute, index) => {
                    let player = getPlayerById(players, minute.id);
                    return (
                      <View
                        style={{ marginBottom: 5 }}
                        key={"starting_" + index}
                      >
                        <Text style={{ fontSize: 8 }}>
                          {positionLabels[minute.position]}:{" "}
                          <Text> {player.name}</Text>
                        </Text>
                      </View>
                    );
                  }
                )}
              </View>
            </View>

            {getSubs(minutes, period, periodLength).map((sub, index) => {
              let player_out = getPlayerById(players, sub.id);
              if (sub.type === "sub") {
                if (
                  sub.hasOwnProperty("finalSuccessor") &&
                  sub.finalSuccessor !== undefined
                ) {
                  let player_in = getPlayerById(players, sub.finalSuccessor.id);
                  return (
                    <View
                      style={{ flexDirection: "row", marginTop: 10 }}
                      key={"sub_" + index}
                    >
                      <View
                        style={{
                          width: 60,
                          fontWeight: "600",
                          fontSize: 14,
                        }}
                      >
                        <Text style={{ fontSize: 8 }}>
                          {getTime(periodLength - (sub.end % periodLength))}
                        </Text>
                      </View>
                      <View style={{ fontSize: 8 }}>
                        <Text>
                          {player_in.name} subs in for {player_out.name} to play{" "}
                          {positionLabels[sub.finalSuccessor.position]}
                        </Text>
                      </View>
                    </View>
                  );
                }
              } else if (sub.type === "switch") {
                if (
                  showSwitches &&
                  sub.hasOwnProperty("switchSuccessor") &&
                  sub.switchSuccessor !== undefined
                ) {
                  return (
                    <View
                      style={{ flexDirection: "row", marginTop: 10 }}
                      key={"sub_" + index}
                    >
                      <View
                        style={{
                          width: 60,
                          fontWeight: "600",
                          fontSize: 14,
                        }}
                      >
                        <Text style={{ fontSize: 8 }}>
                          {getTime(periodLength - (sub.end % periodLength))}
                        </Text>
                      </View>
                      <View style={{ fontSize: 8 }}>
                        <Text style={{ fontSize: 8 }}>
                          {player_out.name} switches positions from{" "}
                          {positionLabels[sub.position]} to{" "}
                          {positionLabels[sub.switchSuccessor.position]}
                        </Text>
                      </View>
                    </View>
                  );
                }
              }

              return null;
            })}
          </View>
        );
      })}
    </View>
  );
}
